module.exports = __webpack_public_path__ + "img/digital04.850ac843.png";